import React from "react";
import Typed from "react-typed";

const TypedComponent = () => {
  return (
    <Typed
      strings={[
        "ShahRiar Alam",
        "a front-end developer",
        "a web developer",
        "a web designer",
      ]}
      typeSpeed={70}
      backSpeed={50}
      loop
    />
  );
};

export default TypedComponent;
